// extracted by mini-css-extract-plugin
export default {"container":"ScrapeComponent_container__VvJiA","addButton":"ScrapeComponent_addButton__PtLO4"};